export default __webpack_public_path__ + "87edb35f57ca0f864466fa1210519835.svg";